import { IToolManagementVM } from '../../models/response/IToolManagementResponse';
import InspectionCycleEnum from '../../constants/enums/inspection-cycle-enum';
import LoanRecordEnum from '../../constants/enums/loan-record-enum';

const initialToolManagementState: Partial<IToolManagementVM> = {
  ToolManagementNo: '',
  ToolName: '',
  OwnerFactoryId: -1,
  ToolManufacturer: '',
  ToolModel: '',
  SerialNo: '',
  EquipmentCategory: '',
  // ProcessUsed's <select> now submits the process name itself (getData prop), so its
  // "please_select" placeholder option value is that literal string, not -1.
  ProcessUsed: 'please_select',
  UsageStatus: 2, //For Available (Unused)
  InspectionStatus: 1, //  For Not Inspected
  InspectionFormat: -1,
  InspectionInterval: null,
  // Pre-work is the default Inspection Cycle for a new tool
  InspectionCycle: InspectionCycleEnum.PreWork,
  CalibrationStatus: 0, //Valid by default
  CalibrationExpiryDate: null,
  NoOfDaysUntilWarning: null,
  PurchaseDate: null,
  DisposalDate: null,
  Location: '',
  ManagingDepartment: '',
  ResponsibleManager: '',
  FixedAssetNo: '',
  TagId: '',
  TeachmebizUrl: '',
  Remarks: '',
  IsActive: true,
  LoanFactoryId: null,
  LoanDate: null,
  LoanRecord: LoanRecordEnum.No,
  PlannedReturnDate: null,
  PartsManufacturer: '',
  ReelModel: '',
  LooseTerminalModel: '',
  ToolType: null,
  InspectionTabs: [],
  CrimpRows: [],
};

export default initialToolManagementState;
